import RootLayout from '../component/Layout';
import TopLogo from '../component/TopLogo';
import styles from './subscription.module.scss';
import styles_mobile from './subscription_mobile.module.scss';
import Img from '../component/Img';
import useScreenWidthBelowThreshold from '../hooks/useScreenWidthBelowThreshold';

export default () => {
  const isScreenWidthBelow700px = useScreenWidthBelowThreshold(700);
  if (isScreenWidthBelow700px) {
    return (
      <RootLayout style={{ height: 'auto' }} className={styles_mobile.wrapper}>
        <TopLogo />
        <Img
          className={styles_mobile.title}
          src="https://cdn.duetapp.net/v1/images/eyJpZCI6IkdKT05TM1pLRElHQ1hYRDRRN0xMU0lFRFJHWVhXTiIsInciOjE1ODQsImgiOjIwMCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjIyNDAzMjY2OTE1NDg3MzgwNTB9"
        />
        <Img
          className={styles_mobile.table}
          src="https://cdn.duetapp.net/v1/images/eyJpZCI6IjVZVElEQ0ZMQkhBRzY3UjMzSE1BQlJYS0ZWVUdaMiIsInciOjc1MCwiaCI6MTY3NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjI5NjU5NDY5NDg5MjIxNzk3NTJ9"
        />
      </RootLayout>
    );
  } else {
    return (
      <RootLayout style={{ height: 'auto' }} className={styles.wrapper}>
        <TopLogo />
        <Img
          className={styles.title}
          src="https://cdn.duetapp.net/v1/images/eyJpZCI6IkdKT05TM1pLRElHQ1hYRDRRN0xMU0lFRFJHWVhXTiIsInciOjE1ODQsImgiOjIwMCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjIyNDAzMjY2OTE1NDg3MzgwNTB9"
        />
        <Img
          className={styles.table}
          src="https://cdn.duetapp.net/v1/images/eyJpZCI6IkJQT1JWSFM2RVhHUVBJWVdZVEJXWURXSFRVQ0g1TCIsInciOjE4MzIsImgiOjI1NzgsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjoxMzMxMDU1NjQ4MDM5NTA1MTE2Mn0"
        />
      </RootLayout>
    );
  }
};
